import { render, staticRenderFns } from "./HistoricoBeneficiarioList.vue?vue&type=template&id=ded6fd64"
import script from "./HistoricoBeneficiarioList.vue?vue&type=script&lang=js"
export * from "./HistoricoBeneficiarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports